import { NgModule } from '@angular/core';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { PopupConfirmDirective } from '@spaq/utils/popup-confirm.directive';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupComponent } from './components';

@NgModule({
	imports: [DialogsModule, SharedComponentsModule, SharedCommonModule],
	declarations: [PopupComponent, PopupConfirmDirective],
	exports: [PopupComponent, DialogsModule, PopupConfirmDirective],
	entryComponents: [PopupComponent]
})
export class PopupModule {}
